import * as yup from 'yup';
type TFunction = (key: string, options?: Record<string, unknown>) => string;

export const initialTopUpsDetails = {
  enterpriseId: undefined,
  enterpriseName: undefined,
  creditsAmount: undefined,
  eurosAmount: undefined,
};

export const topUpsFormDetailsSchema = (translate: TFunction) => {
  return yup.object().shape({
    enterpriseId: yup.string().required(translate('REQUIRED') ?? undefined),
    enterpriseName: yup.string().required(translate('REQUIRED') ?? undefined),
    creditsAmount: yup.number().required(translate('REQUIRED') ?? undefined),
    eurosAmount: yup
      .number()
      .min(1)
      .required(translate('REQUIRED') ?? undefined),
  });
};
